import { get, put, post, del,default as com } from '@/common/api'

let api = {
  /** ****************** 患者 ****************** **/
  queryPatient: (para) => {
    return get('/api/md/patient', para)
  },
  getPatientByIdNo: com.getPatientByIdNo,
  savePatient: com.savePatient,
  queryCard:(para)=>{
     return get(`/api/md/patientCard`,para)
  },
  saveCard:(para)=>{
    return  post(`/api/md/patientCard`,para)
  },
  delCrad:(para)=>{
     return  del(`/api/md/patientCard/${para.id}`)
  },
  saveIdentity: (para) => {
    if (para.id) {
      return put(`/api/md/patient/identity/${para.id}`, para)
    } else {
      return post('/api/md/patient/identity', para)
    }
  },
  delIdentity: (para) => {
    return del(`/api/md/patient/identity/${para.id}`)
  },
  // 获取患者人脸信息
  getIdentity: (para) => {
    return get(`/api/md/patient/identity`, para)
  },
  validateAddress: (para) => post('/api/proxy/hospital/receivingAddressCheck', para), // 配送信息校验
  queryAddress: (para) => get('/api/op/rpDistribution', para), // 根据患者id查询历史配送信息
  saveAddress: (para) => {
    if (para.id) return put(`/api/op/rpDistribution/${para.id}`, para);
    return post('/api/op/rpDistribution', para);
  },
}
export default api
